/** Set when the user finishes the wellbeing flow and chooses "Ir para o início"; UserLayout skips forcing /formulario only for /home while the API still lists pending forms. */
export const PLUMAA_ALLOW_HOME_AFTER_FORM_FLOW_KEY =
	'plumaa_allow_home_after_form_flow';

/** Set after a successful user signup; consumed on first user access before opening forms. */
export const PLUMAA_USER_FIRST_ACCESS_KEY = 'plumaa_user_first_access';

/** Set only by signup flows; gates first-access/tutorial experience and is consumed when tutorial starts. */
export const PLUMAA_USER_SIGNUP_CONTEXT_KEY = 'plumaa_user_signup_context';

/** Set when the welcome screen flag is cleared; indicates the full-site tutorial should run. Cleared when the tutorial is completed or dismissed. */
export const PLUMAA_USER_SITE_TUTORIAL_PENDING_KEY =
	'plumaa_user_site_tutorial_pending';

/** Feature-flag to enable/disable the post-signup site tutorial flow. */
export const ENABLE_USER_SITE_TUTORIAL = false;
